<script>
    import { createEventDispatcher } from "svelte";

    const dispatch = createEventDispatcher();
    import { onMount } from "svelte";
    import {
        Dropdown,
        DropdownItem,
        DropdownMenu,
        DropdownToggle,
    } from "sveltestrap";
    import Constantes from "../Classes/Constantes";
    import Conexoes from "../Classes/Conexoes";
    import Loading from "./Loading.svelte";
    import LoadingTela from "./LoadingTela.svelte";
    
    let api;

    let parametros;
    let nome_coluna_opcoes;
    let nome_coluna_saida;
    let filtravel = true;
    let itens = [];
    export let config;
    let filtereditens = itens;
    let selectedText = "";
    let dropdownOpen = false;
    let inputInvalid = false;
    let showWarning = false; // Variável para controlar se o aviso deve ser exibido
    let dados = null;
    let nome_drop = "";
    let loading=false;
    let isLoading=false;
    export let saida = ""; // Variável para armazenar o objeto completo do item selecionado

    let initialized = false; // Variável de controle

    // Atualiza o texto selecionado apenas uma vez
    $: if (
        saida &&
        !initialized &&
        (!api || !parametros || !nome_coluna_opcoes)
    ) {
        selectedText = saida;
        initialized = true; // Marca como inicializado
    }
    function IniciarParametros() {
        if (!api)
            // Corrigido aqui
            api = config.api;
        //console.log("api" + api);
        if (!parametros)
            // Corrigido aqui
            parametros = config.parametros;
        if (!nome_coluna_opcoes) nome_coluna_opcoes = config.nome_coluna_opcoes;
        if (!nome_coluna_saida) nome_coluna_saida = config.nome_coluna_saida;
        if (filtravel)
            // Corrigido aqui
            filtravel = config.filtravel;
        if (!nome_drop)
            // Corrigido aqui
            nome_drop = config.nome_drop;
        if (itens) itens = config.itens;
        if(config.loading){
            loading =  config.loading;
        }
        

        //console.log("itens" + itens);
    }

    async function CarregaOpcoes() {
        //console.log("aqui1");
        isLoading=true;
        if (parametros && api && !itens && nome_coluna_opcoes) {
            const conexoes = new Conexoes();
            dados = await conexoes.conecta(api, parametros);
            itens = dados.map((item) => item[nome_coluna_opcoes]);
            filtereditens = itens;
            //console.log(itens);
            //console.log("aqui2");
        } else {
            filtereditens = itens;
            //console.log("aqui3");
        }
        //console.log("saoda " + saida);

        selectedText = saida;
        isLoading=false;
    }
    function Retorno() {
        //console.log("no retorno");
        if (!parametros || !api || !nome_coluna_opcoes) {
            dispatch("retorno", selectedText);
            dispatch("retorno_simples", selectedText);
            //console.log("no retorno3" + selectedText);
            ///saida=saida[nome_coluna_saida];

            //console.log("no retorno1" + selectedText);
            dispatch("retorno_edicao", selectedText);
            saida = selectedText;
        } else {
            dispatch("retorno", { nomeDrop: nome_drop, objeto: saida });
            saida = saida[nome_coluna_saida];

            dispatch("retorno_simples", saida);
            dispatch("retorno_edicao", saida);
            //console.log("no retorno2" + saida);
        }
    }
    function filteritens(event) {
        inputInvalid = false;
        dropdownOpen = true;
        const searchText = event.target.value.toLowerCase();
        filtereditens = itens.filter((item) =>
            item.toLowerCase().includes(searchText),
        );
    }

    function selectItem(item) {
        // Procurar o objeto completo correspondente ao item selecionado
        if (parametros && api) {
            saida = dados.find((obj) => obj[nome_coluna_opcoes] === item);
        }
        ////console.log("item "+item)
        ////console.log("tipo "+typeof item)
        //selectedText='babbass';
        selectedText = item;
        dropdownOpen = false; // Fechar dropdown após seleção
        inputInvalid = false; // Resetar validação do input
        showWarning = false; // Esconder o aviso quando uma opção válida é selecionada

        Retorno();
    }

    function handleKeyDown(event) {
        if (event.key === "Enter") {
            VerificacaoPalavraLista();
        }
    }

    function VerificacaoPalavraLista() {
        const searchText = selectedText.toLowerCase();
        if (
            filtereditens.map((item) => item.toLowerCase()).includes(searchText)
        ) {
            dropdownOpen = false;
            // Procurar o objeto completo correspondente ao item selecionadoi
            if (parametros != null) {
                saida = dados.find(
                    (obj) =>
                        obj[nome_coluna_opcoes].toLowerCase() === searchText,
                );
            }

            inputInvalid = false;
            Retorno();
        } else {
            inputInvalid = true;
            selectedText = ""; // Limpar o texto selecionado
            showWarning = true; // Mostrar o aviso de opção inválida
        }
    }

    function handleBlur() {
        const searchText = selectedText.toLowerCase();
        if (
            !filtereditens
                .map((item) => item.toLowerCase())
                .includes(searchText)
        ) {
            inputInvalid = true;
            selectedText = ""; // Limpar o texto selecionado
            showWarning = true; // Mostrar o aviso de opção inválida
        } else {
            inputInvalid = false;
            // VerificacaoPalavraLista();
        }
    }

    onMount(async () => {
        document.addEventListener("click", (event) => {
            if (!event.target.closest(".dropdown")) {
                dropdownOpen = false;
            }
        });
        await config;
        //console.log("saida" + saida);
        await saida;
        //console.log(config);
        //console.log("saida" + saida);

        //console.log("iniciando saida " + saida + "_");
        if (saida) {

            selectedText = saida;

            
            filtereditens = saida;
        }
        IniciarParametros();

        CarregaOpcoes();
    });
</script>
<LoadingTela {isLoading} />
<div style="position: relative;">
    {#if !filtereditens}
        <Loading carregando={true} />
    {:else}
        <Dropdown
            isOpen={dropdownOpen}
            toggle={() => {
                dropdownOpen = !dropdownOpen;
            }}
        >
            <input
                class="form-control"
                type="text"
                bind:value={selectedText}
                on:click={() => {
                    dropdownOpen = !dropdownOpen;
                }}
                on:input={filteritens}
                on:keydown={handleKeyDown}
                on:blur={handleBlur}
                style={inputInvalid
                    ? "border: 5px solid red"
                    : "border:1px solid #ced4da"}
                placeholder={Constantes.msg_placeholder_selecao}
                readonly={!filtravel}
            />
            {#if inputInvalid}
                <div
                    style="position: absolute; top: -25px; left: 0; background-color: #ffcccc; color: red; padding: 5px; border-radius: 5px;"
                >
                    {Constantes.msg_opcao_invalida}
                </div>
            {/if}
            <DropdownMenu right={true}>
                {#if filtereditens != "" && filtereditens.length > 0 && dropdownOpen}
                    {#each filtereditens as item}
                        <DropdownItem on:click={() => selectItem(item)}
                            >{item}</DropdownItem
                        >
                    {/each}
                {:else}
                    <DropdownItem disabled
                        >{Constantes.msg_item_nao_encontrado}</DropdownItem
                    >
                {/if}
            </DropdownMenu>
        </Dropdown>
    {/if}
</div>
